import { useFragment, useMutation } from '@apollo/client/react';
import { toast } from 'sonner';

import { type IUser, UserRoleEnum } from 'src/graphql/schema';
import { EditUserDocument } from 'src/graphql/actions/user/editUser.mutation';
import { ClientError, getApiError } from 'src/utils/errors';
import { UserForm, type IUserForm } from 'src/components/User';

import { useUsers, UserFragment } from '../model';

const disableFields = ['email'];

const EditUser = () => {
  const {
    ui: { userId, closeDialog },
  } = useUsers();
  const [editMember] = useMutation(EditUserDocument);

  const user = useFragment<IUser>({
    fragment: UserFragment,
    from: {
      __typename: 'User',
      id: userId,
    },
  });

  if (!user) return null;

  const onSubmit = async (dataForm: IUserForm) => {
    if (!userId) return;

    try {
      const { data } = await editMember({
        variables: {
          userId,
          userInput: {
            name: dataForm.fullName,
            role: dataForm.role,
            phone: dataForm.phone,
          },
        },
      });
      if (data?.editUser?.success) {
        toast.success('Member updated!');
        closeDialog();
      } else {
        throw new ClientError(data?.editUser?.errors?.[0]);
      }
    } catch (error) {
      getApiError(error, toast.error);
    }
  };

  const defaultValues = {
    fullName: user.data.name || '',
    email: user.data.email || '',
    role: user.data.role || UserRoleEnum.Admin,
    phone: user.data.phone || '',
  };

  return (
    <UserForm
      onSubmit={onSubmit}
      btnText="Save"
      defaultValues={defaultValues}
      disableFields={disableFields}
      isOwner={user.data.role === UserRoleEnum.Owner}
      onCancel={closeDialog}
    />
  );
};

export default EditUser;
